// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".TypeWriter-cls1___679320020693d882394{/*!*/}.TypeWriter-cls2___8e6450823eb04b0b2e8{position:absolute;visibility:hidden;height:auto;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "TypeWriter-cls1___679320020693d882394",
	"cls2": "TypeWriter-cls2___8e6450823eb04b0b2e8 TypeWriter-cls1___679320020693d882394"
};
export default ___CSS_LOADER_EXPORT___;
